export default function KpiCard({
    label,
    value,
    sub,
    icon: Icon,
    accent = "from-blue-500/20 to-blue-500/0",
    testId,
}) {
    return (
        <div className="glass-card p-5 animate-fade-up" data-testid={testId}>
            <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                    <div className="label-uppercase">{label}</div>
                    <div className="mt-2 font-display text-3xl font-bold tracking-tight">
                        {value}
                    </div>
                    {sub && (
                        <div className="mt-1.5 text-xs text-slate-400">{sub}</div>
                    )}
                </div>
                {Icon && (
                    <div
                        className={`h-11 w-11 rounded-xl bg-gradient-to-br ${accent} grid place-items-center border border-white/10`}
                    >
                        <Icon size={20} weight="duotone" className="text-white" />
                    </div>
                )}
            </div>
        </div>
    );
}
